import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class BrowserLocationService {
    private popSubject: Subject<boolean> = new Subject();
    private _backClicked: boolean;

    public get backClicked(): boolean {
        return this._backClicked;
    }

    public set backClicked(value: boolean) {
        this._backClicked = value;
    }

    public setPopSubject(value: boolean): void {
        this.popSubject.next(value);
    }

    constructor(private location: Location) {
        this.location.subscribe(() => {
            this.backClicked = true;
        });
    }

    public get popEvent$(): Observable<boolean> {
        return this.popSubject.asObservable();
    }
}
